export default {
  methods: {
    isEmbedded() {
      return window.self !== window.top;
    },
  },
};
